<template>
    <td>
        <component
            :is="column.component"
            v-if="column.component && column.value"
            :model="model"
            :column="column"
            :store-name="storeName"
        />
        <span v-else>
            {{ mappedValue }}
        </span>
    </td>
</template>

<script>
    export default {
        props: {
            model: {
                type: Object,
                required: true,
            },
            column: {
                type: Object,
                required: true,
            },
            storeName: {
                type: String,
                required: true,
            },
        },
        computed: {
            mappedValue() {
                return this.$store.getters[`${this.storeName}/mappedColumnValue`](this.model, this.column);
            },
        },
    };
</script>
